<template>
  <div class="grid-video-playlist">
    <div class='row' v-if="!playerVisible">
      <div class='col-sm-6 col-md-3' v-for="(videoAsset, i) in videoAssets" :key="i">
        <VideoCard v-bind:video-asset="videoAsset" :key="i">
        </VideoCard>
      </div>
    </div>
    <div class='row' v-if="playerVisible">
      <div class='col-md-9 video-player-container'>
        <MuxAttendeeVideoPlayer
          v-if="selectedVideoAsset"
          v-bind:video-asset="selectedVideoAsset"
          v-bind:event-attendee="eventAttendee"
          theme="city"
        >
        </MuxAttendeeVideoPlayer>

        <div class='d-flex flex-column' v-if="selectedVideoAsset">
          <h4>{{ selectedVideoAsset.title }}</h4>
          <span v-html="selectedVideoAsset.description"></span>
        </div>

      </div>
      <div class='col-md-3 video-playlist-container'>
        <VideoItemSidebar
          v-for="videoAsset in videoAssets"
          @click.native="selectVideoAsset(videoAsset)"
          v-bind:video-asset="videoAsset"
          v-bind:poster="videoAsset.poster"
          v-bind:gif="videoAsset.gif"
          v-bind:selected="videoAsset.id === selectedVideoAsset.id"
          :key="videoAsset.video_playlist_video_asset_id"
        >
        </VideoItemSidebar>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../EventBus.js'
import VideoItemSidebar from './VideoItemSidebar.vue'
import VideoCard from './VideoCard.vue'
import MuxAttendeeVideoPlayer from '../video/MuxAttendeeVideoPlayer.vue'
export default {

  components: {
    VideoItemSidebar,
    VideoCard,
    MuxAttendeeVideoPlayer
  },

  props: {
    videoAssets: {
      type: Array,
      default: () => []
    },
    eventAttendee: {
      type: Object,
      default: () => {}
    },
    selectedVideoAsset: {
      type: [Object, Boolean],
      default: false
    },
    playerVisible: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    selectVideoAsset (videoAsset) {
      EventBus.$emit('video-asset-selected', videoAsset)
    }
  },

  created () {
    console.log(EventBus)
  }
  
}



</script>

<style>
  .video-playlist-container .video-card {
    background-color: transparent;
    border: none;
  }

  .video-playlist-container .video-item-sidebar {
    background-color: transparent;
    margin-bottom: 0;
    border: none;
    display: flex;
    flex-direction: row;
  }
</style>